// extracted by mini-css-extract-plugin
export default {"main":"Score_main__ot8vW","icon":"Score_icon__1ZtdP"};